import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Loader } from 'semantic-ui-react'

/**
 * A common way to show a full screen loading indicator.
 */
export default function LoadingWrapper ({ loading, message, children }) {
  return (
    <div>
      <Modal open={loading} basic size='small' dimmer='inverted' className='semantic-ui'>
        <Modal.Dimmer inverted>
          <Loader>{message}</Loader>
        </Modal.Dimmer>
      </Modal>
      {children}
    </div>
  )
}

LoadingWrapper.propTypes = {
  loading: PropTypes.bool.isRequired,
  message: PropTypes.string,
  children: PropTypes.node
}

LoadingWrapper.defaultProps = {
  message: ''
}
